"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupItemChip = exports.GroupSubHeading = exports.GroupName = exports.GroupItemGrid = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Chip = _interopRequireDefault(require("../Chip"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    background-color: ", ";\n    ", "\n    ", "\n        border: 0px;\n    height: 24px;\n    color: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n    opacity: 0.7;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    background-color: ", ";\n    padding: ", ";\n    cursor: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GroupItemStripped = function GroupItemStripped(_ref) {
  var isSelected = _ref.isSelected,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["isSelected"]);
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], props);
};

var GroupItemGrid = (0, _styledComponents["default"])(GroupItemStripped)(_templateObject(), function (props) {
  return props.isSelected ? _colors["default"].blueberry[200] : 'inherit';
}, _spacing["default"][4], function (props) {
  return props.onClick ? 'pointer' : 'auto';
});
exports.GroupItemGrid = GroupItemGrid;

var GroupNameStripped = function GroupNameStripped(_ref2) {
  var isSelected = _ref2.isSelected,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["isSelected"]);
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], props);
};

var GroupName = (0, _styledComponents["default"])(GroupNameStripped)(_templateObject2(), function (props) {
  return props.isSelected ? _colors["default"].lychee[100] : _colors["default"].blackberry[700];
});
exports.GroupName = GroupName;

var GroupSubHeadingStripped = function GroupSubHeadingStripped(_ref3) {
  var isSelected = _ref3.isSelected,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["isSelected"]);
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], props);
};

var GroupSubHeading = (0, _styledComponents["default"])(GroupSubHeadingStripped)(_templateObject3(), function (props) {
  return props.isSelected ? _colors["default"].lychee[100] : _colors["default"].blackberry[700];
});
exports.GroupSubHeading = GroupSubHeading;
var newGroupChipStyles = (0, _styledComponents.css)(_templateObject4(), _colors["default"].blueberry[400]);
var draftGroupChipStyles = (0, _styledComponents.css)(_templateObject5(), _colors["default"].orange[300]);

var GroupItemChipStripped = function GroupItemChipStripped(_ref4) {
  var isNew = _ref4.isNew,
      isDraft = _ref4.isDraft,
      props = (0, _objectWithoutProperties2["default"])(_ref4, ["isNew", "isDraft"]);
  return /*#__PURE__*/_react["default"].createElement(_Chip["default"], props);
};

var GroupItemChip = (0, _styledComponents["default"])(GroupItemChipStripped)(_templateObject6(), _colors["default"].strawberry[500], function (props) {
  return props.isNew ? newGroupChipStyles : '';
}, function (props) {
  return props.isDraft ? draftGroupChipStyles : '';
}, function (props) {
  return props.isDraft ? _colors["default"].blackberry[400] : _colors["default"].lychee[100];
});
exports.GroupItemChip = GroupItemChip;